module.exports = __webpack_public_path__ + "img/phone.fe49d53e.png";